import React from "react";

const CALENDLY_BASE_URL = "https://calendly.com/nuralhuda-co/30min";

// Nur Al Huda theme: dark green accent for buttons/date circles; text stays Calendly default (no # in URL params)
const CALENDLY_PRIMARY_COLOR = "144040";

function buildCalendlyEmbedUrl() {
  const params = new URLSearchParams({
    primary_color: CALENDLY_PRIMARY_COLOR,
  });
  return `${CALENDLY_BASE_URL}?${params.toString()}`;
}

/**
 * Calendly iframe embed for 1:1 booking.
 * URL params (primary_color, text_color, background_color) match the site theme; may require Calendly paid plan.
 */
export default function CalendlyEmbed() {
  const embedSrc = buildCalendlyEmbedUrl();

  return (
    <div className="calendly-embed-inner" style={{ minWidth: 320, height: 700 }}>
      <iframe
        title="Book a meeting with Calendly"
        src={embedSrc}
        style={{ width: "100%", height: 700, minHeight: 650, border: 0 }}
        loading="lazy"
      />
    </div>
  );
}
